import React from 'react';

function Alert({type, className, children}) {
    return (
        <div className={"alert alert-" + type + " d-flex align-items-center " + (className ? className : '')}>
            {children}
        </div>
    )
}

export default React.memo(Alert);